$("body").ready(() => {
	// listen for flash messages in XHR response headers and add them to the notice div
	$(document).on("ajaxComplete", (event, request) => {
		const xMessages = decodeURIComponent(
			encodeURIComponent(request.getResponseHeader("X-Messages")),
		);
		const messagesHash = JSON.parse(xMessages);

		for (const displayType in messagesHash) {
			pp.notifications.display(displayType, messagesHash[displayType]);
		}
	});

	$(document).on("page:change", () => {
		// Set timer to fade out notices that are backed into the HTML
		const $presentNoticesToFadeOut = $("#flash-messages").children(
			":not(.FlashMessage--dismissable)",
		);
		if ($presentNoticesToFadeOut.length) {
			$presentNoticesToFadeOut.each((elem) => {
				// @ts-expect-error
				pp.notifications.noticesToFadeOut.push([
					// @ts-expect-error
					$(elem).attr("data-display-type"),
					// @ts-expect-error
					$(elem).find(".FlashMessage__content").html(),
				]);
			});
			if (pp.notifications.noticesToFadeOut.length) {
				pp.notifications.enqueueFadeOut();
			}
		}
		// Re-add the last notices after page change if its timeout is not reached yet (the timeout will start anew)
		else if (pp.notifications.noticesToFadeOut.length) {
			const oldnoticesToFadeOut = pp.notifications.noticesToFadeOut;
			pp.notifications.noticesToFadeOut = [];
			while (oldnoticesToFadeOut.length > 0) {
				const noticeData = oldnoticesToFadeOut.shift();
				pp.notifications.display(noticeData[0], noticeData[1]);
			}
		}
	});
});

// New submodule
export default {
	displayDuration: 10000, // time until notices gets faded out
	noticesToFadeOut: [],
	fadeTimeout: undefined,
	lastFadeOutTrigger: undefined,

	/**
	 * Add the given notice on top of the notice list  and set the timeout to fade out OR displays the error modal if the given displayType is 'error'
	 * @param {Object} displayType of notice, should be 'error', or 'notice'
	 * @param {Object} msg
	 */
	display(displayType, msg, options = {}) {
		if (!msg) {
			console.error("Could not display pp.notifications - no message given.");
			return;
		}

		if (!pp.fayeDebug) {
			// The fayeDebug messages are shown as notice overlays, so prevent them (and all others) from also appearing in the console
			pp.log(
				"NOTICE OVERLAY displaying -- displayType, msg, options:",
				displayType,
				msg,
				options,
			);
		}

		if (["notice_modal", "error"].includes(displayType)) {
			var modalShowDelay = 0;
			if ($("div.modal.in").length) {
				var modalShowDelay = 500;
				$("div.modal.fade.in").modal("hide");
			}
		}

		if (["error", "error_modal"].includes(displayType)) {
			$("#error-modal").find("div.modal-body > p").html(msg);
			setTimeout(() => {
				$("#error-modal").modal("show");
				// @ts-expect-error
			}, modalShowDelay);
			$("div.error").append(`<div>${msg}</div>`); // For unionslabor landing page
		} else if (displayType == "notice_modal") {
			$("#notice-modal").find("div.modal-body > p").html(msg);
			setTimeout(() => {
				$("#notice-modal").modal("show");
				// @ts-expect-error
			}, modalShowDelay);
		} else if (displayType == "notification_banner") {
			$("#notification-banner").removeClass("show-bar hide-bar orange green");
			$("#notification-banner").addClass(
				options.showBar ? "show-bar" : "hide-bar",
			);
			$("#notification-banner").addClass(options.colorClass || "orange"); // Either the defined color class or default to 'bg-theme-dark-l5'
			$("#notification-banner").find("span").html(msg);
		} else if ($("#flash-messages").length) {
			// Is not always present in the page layout
			// Compose and display a flash message
			const flashMsgHtml = this.flashMessageFromTemplate(
				displayType,
				msg,
				// @ts-expect-error
				options,
			);
			if (
				$("#flash-messages").find(`div:contains('${$(flashMsgHtml).text()}')`)
					.length
			) {
				return;
			}
			const $prependedMsg = $("#flash-messages").prepend(flashMsgHtml);

			const navVisible =
				// @ts-expect-error
				$(document).scrollTop() < $(".navbar:visible").outerHeight();
			const baseGridUnit = parseInt(
				pp.viewHelpers.detectCssRuleFor(".FlashMessage__dismiss", "right"),
				10,
			);
			const flashMsgsTopOffset = navVisible
				? $(".navbar:visible").outerHeight()
				: $(document).scrollTop();
			pp.viewHelpers.fixElOnScroll($("#flash-messages"), baseGridUnit);
			// @ts-expect-error
			$("#flash-messages").css("top", flashMsgsTopOffset + baseGridUnit + "px");

			if (options.dismissable) {
				$prependedMsg.find("a").one("click", function () {
					pp.notifications.animateFadeOut(
						$(this).closest(".FlashMessage"),
						undefined,
						100,
					);
				});
			} else {
				// @ts-expect-error
				this.noticesToFadeOut.push([displayType, msg]);
				this.enqueueFadeOut();
			}
		}
	},

	flashMessageFromTemplate(
		displayType,
		message,
		{ dismissable, attachLinkToPresentLink, category },
	) {
		const $message = $(".j-flash-message-template")
			.find(".FlashMessage")
			.clone();
		$message.addClass(`FlashMessage--${displayType}`);
		$message.attr("data-display-type", displayType);
		if (dismissable) {
			$message.addClass("FlashMessage--dismissable");
		}

		$message.find(".FlashMessage__content").html(message);
		if (attachLinkToPresentLink) {
			$message.find("a").on("click", (event) => {
				const $remoteLinkInContent = $("div.content").find(
					`a[href='${$(event.target).attr("href")}'][data-remote]`,
				);
				if (!$remoteLinkInContent.length) {
					return;
				}
				event.preventDefault();
				$remoteLinkInContent.trigger("click");
			});
		}
		if (category) {
			$message.attr("data-category", category);
			const $sameCategoryElemToFadeOut = $("#flash-messages").find(
				`[data-category='${category}']`,
			);
			this.animateFadeOut($sameCategoryElemToFadeOut, undefined, 500);
		}
		return $message;
	},

	/**
	 * Sets enqueueFadeOut timer for bottom notices
	 */
	enqueueFadeOut() {
		if (
			this.lastFadeOutTrigger === undefined ||
			Date.now() > this.lastFadeOutTrigger + this.displayDuration
		) {
			clearTimeout(pp.notifications.fadeTimeout); // just to be sure
			this.fadeTimeout = undefined;
		} else if (this.fadeTimeout !== undefined) {
			return;
		}

		// @ts-expect-error
		this.lastFadeOutTrigger = Date.now();
		// @ts-expect-error
		pp.notifications.fadeTimeout = setTimeout(() => {
			if (!pp.notifications.noticesToFadeOut.length) {
				return;
			}
			const topMostNotice = $("#flash-messages")
				.children(":not(.FlashMessage--dismissable)")
				.first();
			pp.notifications.animateFadeOut($(topMostNotice), () => {
				if (!pp.notifications.noticesToFadeOut.length) {
					return;
				}
				pp.notifications.fadeTimeout = undefined;
				pp.notifications.enqueueFadeOut();
			});
		}, pp.notifications.displayDuration);
	},

	animateFadeOut($elem, callback, timeOut) {
		// @ts-expect-error
		var timeOut = timeOut || 500;
		$elem.animate(
			{
				opacity: 0,
			},
			timeOut,
			"swing",
			() => {
				const elemIndex = pp.notifications.noticesToFadeOut.findIndex(
					(noticeData) => {
						return noticeData[1] == $elem.find(".FlashMessage__content").html();
					},
				);
				pp.notifications.noticesToFadeOut.splice(elemIndex, 1);
				$elem.remove();
				if (callback !== undefined) {
					callback();
				}
			},
		);
	},
};
